import apiClient from "../client";

const objApi = apiClient(
   "/verifyRecaptcha"
);

export const verifyRecaptcha = (recaptchaResponse) => {
  console.log("verifyRecaptcha Api:");
  console.log(recaptchaResponse);
  try {
      return objApi.get({
        token:recaptchaResponse,
      });
  } catch(e) {
    // statements
    console.log(e);
  }
};

